import { postCrossOriginFormData } from '../services/fetch';
import { isEmpty } from 'lodash';

export default {

    reportError: async function (error, errorInfo) {
        try {
            if (error) {

                let formData = new FormData();
                formData.append('Description', error);
                if (errorInfo && !isEmpty(errorInfo)) {
                    formData.append('Extra', errorInfo);
                }
                else {
                    formData.append('Extra', error);
                }
                formData.append('Email', 'info@bitsabound.com');
                formData.append('ScoutUserName', 'WebAppCrashReport');
                formData.append('ScoutProject', 'RevAuc');
                formData.append('ScoutArea', 'Seller Portal');
                formData.append('ForceNewBug', 0);

                const url = 'https://bitsbugs.fogbugz.com/scoutSubmit.asp';
                const response = await postCrossOriginFormData(url, formData, false);

            }
        }
        catch (e) {

        }
    }
}